import React from 'react';
import ToggleRow from '@/components/General/inputs/ToggleRow';

export default function FeeCoverageToggle({ allowed, value, onChange, disabled = false }) {
    if (!allowed) return null;
    return (
        <ToggleRow
            label="Cover Fees"
            description="Include processing fees so the organization receives the full amount."
            value={value}
            onValueChange={onChange}
            disabled={disabled}
            testID="cover-fees-toggle"
        />
    );
}
